module.exports = __webpack_public_path__ + "static/media/baxter-storey-logo-charcoal.d7b6d0cd.svg";